// Single-flight cache around the zoid host token.
//
// The token is issued once by the AhaSlides host per iframe load, so we
// resolve it exactly once per page lifetime and hand the same Promise to
// every caller. Aborting one consumer (e.g. a React effect unmounting)
// must NOT poison the cache for later callers — that's why we don't take
// an AbortSignal here.
//
// `clearSessionToken()` exists for tests and for the (rare) case where a
// caller knows the cached token is stale and wants the bridge re-polled.

import { getZoidToken } from "../zoidToken";

let pending: Promise<string | null> | null = null;

export function getSessionToken(): Promise<string | null> {
  if (!pending) {
    // .catch(() => null) keeps the cache populated even if the bridge
    // throws — the next call returns null instead of re-throwing.
    pending = getZoidToken().catch(() => null);
  }
  return pending;
}

export function clearSessionToken(): void {
  pending = null;
}
